export const initialState = {
  state: 'preloader',
  previousStates: [],
};
